import React, { type FC } from 'react';
import { ReportSSRFailOnUse } from '@jira/ssr__rendering-guard/src/ReportSSRFailOnUse.tsx';
import type { PlaceholderProps } from './PlaceholderProps.tsx';

export const PlaceholderSsrFallback: FC<{
	name: string;
	reportSsrFallback: NonNullable<PlaceholderProps['reportSsrFallback']>;
}> = ({ name, reportSsrFallback }) => {
	const options = typeof reportSsrFallback === 'object' ? reportSsrFallback : undefined;
	return (
		<ReportSSRFailOnUse
			{...options}
			pageId={name}
			fallbackId={options?.fallbackId ?? name}
			displayErrorInStaging
		/>
	);
};
